import { store } from '@/store';

export class FinderBase {
    public numeroPagina: number = 1;
    public dimensionePagina: number = store.state.ui.dimensionePaginaListe;

    public idFornitore!: string;
}